/**
 * Dates as the work order pages show them, in one fixed locale so every panel reads alike and
 * matches {@link formatShortDateTime}: `Sep 17, 2026`, and `Oct 19, 2026, 03:57 PM` with the time.
 */

/** A calendar date (`YYYY-MM-DD`) is a day where the reader is, not midnight UTC. */
const toDate = (value: string): Date => new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00` : value)

/** `Sep 17, 2026`, from a timestamp or a calendar date. */
export const formatDate = (value: string): string =>
	toDate(value).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })

/** `Oct 19, 2026, 03:57 PM`. */
export const formatDateTime = (iso: string): string =>
	new Date(iso).toLocaleString('en-US', {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	})

/** `21 Oct 2026` — the day-first form the work-order list's Deadline column uses. */
export const formatDayMonthYear = (value: string): string =>
	toDate(value).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })

/** `23 Oct 2026 (04:00 PM)` — a deadline with its time, day first. */
export const formatDeadline = (iso: string): string => {
	const date = new Date(iso)
	const time = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
	return `${formatDayMonthYear(iso)} (${time})`
}
